import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { environment } from '../environments/environment';
import { DOCUMENT } from '@angular/common';
import { request } from 'node:http';

interface Product {
  ItemNmbr: string;
  WebName: string;
  WebDescription: number; //Friendly identifier for the web
  WebCategory?: string; //Friendly identifier for the web
  WebClass?: string; //Friendly identifier for the web
  ExtendedDescription?: string;
  Class?: string; //BO class identifier
  FriendlyName?: string;
  Vendor?: string;
  ImageURL?: string;
  MasterItemNmbr?: string;
  MetaTag?: string;
  Name?: string; //this is the list of the registered states - i did this generic property name just to piss Paul off
  OverrideRegStatesListingWithSeeRep?: boolean;
  SellUofM?: string;
  ImageID?: string;
  SellingPrice?: number;
  Agency?: boolean;
  Cost?: number;
  EQUOMQTY?: number;
  zzItemNmbr?: string;
  ItemPosition?: number;
  mt?: string;

}


@Injectable({
  providedIn: 'root'
})




export class Dotcom2024Service {

  constructor(private http: HttpClient, @Inject(DOCUMENT) private dom) { }

  appAPIUrl = environment.appAPIUrl;
  harfilesAPIUrl = environment.harfilesAPIUrl;
  activeSubMenu: string = "";
  activeMainMenu: string = "";
  activePage: string = "";
  // activeLink: string = "";

  quickSearchInput: string = "";
  searchTerm: string = "";

  productSearch: string = "";
  productFilter: string = "";
  // productCategoriesSelected: string = "";
  sku: string = "";
  desiredDoc: string = "";
  partnership: string = "";
  partnershipId: string = "";
  products: Product[] = []; //products array of summary product objects - this is what is displayed on the page
  productsMasterList: Product[] = []; //total list from sql query - when more button is clicked it uses this array to add more products to the products array
  product: Product = { ItemNmbr: '', WebName: '', WebDescription: 0, WebCategory: '', WebClass: '', Class: '', FriendlyName: '', Vendor: '', ImageURL: '', MasterItemNmbr: '', MetaTag: '', Name: '', OverrideRegStatesListingWithSeeRep: false, Agency: false };
  productLinkedItems: Product[] = []; //array of items that are associated to the item being looked on on the item detail page 
  productAlternateItems: Product[] = [];

  resourceFilteredPosts: any[] = []; //posts that are displayed on the resources page
  blogCategories: any[] = []; //list of blog categories
  blogCategoriesSelected: string = ""; //selected blog category
  blogSearchKey: string = ""; //search key for blog search
  blogPagingStart: number = 0; //start of the paging for the blog posts

  zipCodeEntered: string = "";
  repsMasterList: any[] = [];

  warehouses: any[] = [];
  corpOffice: any = {};

  bhGUID: string = "";

  displayLabelNotice: boolean = false;
  displaySDSNotice: boolean = false;
  displayWarning: boolean = false;
  warningText: string = "";
  displaySuccess: boolean = false;
  successText: string = "";

  cartCount: number = 0;
  
  // createCanonicalURL(url?: string) {
  //   let link: HTMLLinkElement = this.dom.createElement('link');
  //   link.setAttribute('rel', 'canonical');
  //   this.dom.head.appendChild(link);
  //   link.setAttribute('href', this.dom.URL);

  // }

  LastMainMenuHovered(menu: string) {
    sessionStorage.setItem('lastMainMenuHovered', menu);
  }

  DisplaySubMenu(menu: string) {
    this.activeSubMenu = menu
  }

  GetProductDetailSearchResults(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetProductDetailSearchResults/`;
    return this.http.post<any>(url, {
      KeyWordSearch: this.productSearch,
      LocnCode: '',
      MetaTag: '',
      OffsetNumber: '0',
      Partnership: this.partnership,
      RequestType: 'ProductSearchResults',
      Vendor: '',
      WebCategory: '', // this.productCategoriesSelected,
      WebClass: ''
    })
      .pipe(
        catchError(this.handleError<any[]>('GetProductDetailSearchResults', []))
      );
  }

  GetEOPProductSearchResults(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetEOPProductSearchResults/`;
    return this.http.post<any>(url, {
      // KeyWordSearch: this.productSearch,
      // LocnCode: '',
      // MetaTag: '',
      // OffsetNumber: '0',
      Partnership: this.partnership,
      // RequestType: 'ProductSearchResults',
      // Vendor: '',
      // WebCategory: '',
      // WebClass: ''
    })
      .pipe(
        catchError(this.handleError<any[]>('GetEOPProductSearchResults', []))
      );
  }

  GetProductDetail(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetProductDetail/`;
    return this.http.post<any>(url, {
      ItemNmbr: this.sku,
      PartnershipId: this.partnershipId
    })
      .pipe(
        catchError(this.handleError<any[]>('GetProductDetail', []))
      );
  }

  GetDraftDetails(customerNumber: string, customerAddress: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetDraftDetails/`;
    return this.http.post<any>(url, {
      CustomerNumber: customerNumber,
      CustomerAddressCode: customerAddress,
      RequestedBy: JSON.parse(sessionStorage.getItem('loggedInMyHarrellsUser')).Email,
      OrderType: (sessionStorage.getItem('EOPMode') == 'true') ? 'bh' : 'olo'
    })
      .pipe(
        catchError(this.handleError<any[]>('GetDraftDetails', []))
      );
  }

  DeleteDraftOrder(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/DeleteDraftOrder/`;
    return this.http.post<any>(url, {
      CustomerNumber: sessionStorage.getItem('CustomerNumberSelected'),
      CustomerAddressId: sessionStorage.getItem('PartnershipCustomerAddressCodeselected'),
      RequestedBy: JSON.parse(sessionStorage.getItem('loggedInMyHarrellsUser')).Email,
    })
      .pipe(
        catchError(this.handleError<any[]>('DeleteDraftOrder', []))
      );
  }

  AddUpdateDraft(notes: string, deliveryDate: string, po: string, status: string, dispatchNotes: string): Observable<any[]> {

    let loggedInUser = JSON.parse(sessionStorage.getItem('loggedInMyHarrellsUser')).Email;
    // if (loggedInUser == null) {
    //   loggedInUser = ""; //should never happen
    // }


    const url = `${this.appAPIUrl}/Harrells/AddUpdateDraft/`;
    return this.http.post<any>(url, {
      CustomerNumber: sessionStorage.getItem('CustomerNumberSelected'),
      CustomerAddress: sessionStorage.getItem('PartnershipCustomerAddressSelected'), //sessionStorage.PartnershipCustomerAddressSelected, 
      Notes: notes,
      DeliveryDate: deliveryDate,
      ShoppingCart: sessionStorage.getItem('ShoppingCart'), //sessionStorage.shoppingCart, 
      PartnershipId: sessionStorage.getItem('PartnershipId'), //sessionStorage.PartnershipId, 
      PartnershipName: sessionStorage.getItem('PartnershipName'), //sessionStorage.PartnershipName, 
      PartnershipSalesPersonId: sessionStorage.getItem('PartnerSalesPersonId'), //partnershipSalesPersonId, 
      RequestedBy: loggedInUser, //response[0].Name, 
      OrderStatus: status,
      PO: po,
      OrderType: (sessionStorage.getItem('EOPMode') == 'true') ? 'bh' : 'olo',
      CustomerAddressCode: sessionStorage.getItem('PartnershipCustomerAddressCodeselected'), //customerAddressCode
      DispatchNotes: dispatchNotes
    })
      .pipe(
        catchError(this.handleError<any[]>('AddUpdateDraft', []))
      );
  }

  GetAllFormsInBlobStorage(folderPath: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/HarrellsAdmin/GetAllBlobNamesInFolder/`;
    return this.http.post<any>(url, {
      Name: folderPath //example could be 'assets/forms/' -- must match exactly to the folder in the blob storage account
    })
      .pipe(
        catchError(this.handleError<any[]>('GetAllBlobNamesInFolder', []))
      );
  }

  GetAllForms(): Observable<any[]> {
    const url = `${this.appAPIUrl}/HarrellsAdmin/GetAllForms/`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetAllForms', []))
      );
  }

  GetLinkedItems(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetLinkedItems/`;
    return this.http.post<any>(url, {
      ItemNmbr: this.sku
    })
      .pipe(
        catchError(this.handleError<any[]>('GetLinkedItems', []))
      );
  }

  GetAlternateItems(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetAlternateItems/`;
    return this.http.post<any>(url, {
      ItemNmbr: this.sku
    })
      .pipe(
        catchError(this.handleError<any[]>('GetAlternateItems', []))
      );
  }

  GetProductCategories(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetProductCategories/`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetProductCategories', []))
      );
  }

  GetProductCategoryGroup(categoryGroupName): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetProductCategoryGroup/`;
    return this.http.post<any>(url, {
      CategoryGroupName: categoryGroupName
    })
      .pipe(
        catchError(this.handleError<any[]>('GetProductCategoryGroup', []))
      );
  }

  GetMarketsFeaturedProducts(marketPage: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetMarketsFeaturedProducts/`;
    return this.http.post<any>(url, {
      MarketPage: marketPage
    })
      .pipe(
        catchError(this.handleError<any[]>('GetMarketsFeaturedProducts', []))
      );
  }

  GetMarketsFeaturedBlogs(marketPage: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetMarketsFeaturedBlogs/`;
    return this.http.post<any>(url, {
      MarketPage: marketPage
    })
      .pipe(
        catchError(this.handleError<any[]>('GetMarketsFeaturedBlogs', []))
      );
  }

  GetAllActiveBlogs(): Observable<any[]> {
    const url = `${this.appAPIUrl}/HarrellsAdmin/GetAllActiveBlogs/`;


    return this.http.post<any>(url, {
      PagingStart: this.blogPagingStart,
      PublishedOnly: true, //only get published blogs -- those with a publish date 
      Category: this.blogCategoriesSelected,
      SearchKey: this.blogSearchKey,
    })
      .pipe(
        catchError(this.handleError<any[]>('GetAllActiveBlogs', []))
      );
  }

  GetBlog(postAlias: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetBlog/`;
    return this.http.post<any>(url, {
      PostAlias: postAlias
    })
      .pipe(
        catchError(this.handleError<any[]>('GetBlog', []))
      );
  }


  GetRepsActiveBlogs(repId: number): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetRepsActiveBlogs/`;
    return this.http.post<any>(url, {
      Id: repId
    })
      .pipe(
        catchError(this.handleError<any[]>('GetRepsActiveBlogs', []))
      );
  }

  GetAllBlogCategories(): Observable<any[]> {
    const url = `${this.appAPIUrl}/HarrellsAdmin/GetBlogCategories/`;
    return this.http.post<any>(url, {
      ActiveOnly: true
    })
      .pipe(
        catchError(this.handleError<any[]>('GetBlogCategories', []))
      );
  }

  GetFeaturedBlog(): Observable<any[]> {
    const url = `${this.appAPIUrl}/HarrellsAdmin/GetFeaturedBlog/`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetFeaturedBlog', []))
      );
  }

  GetOtherFeaturedBlogs(): Observable<any[]> {
    const url = `${this.appAPIUrl}/HarrellsAdmin/GetOtherFeaturedBlogs/`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetOtherFeaturedBlogs', []))
      );
  }

  GetRelatedBlogs(postAlias: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetRelatedBlogs/`;
    return this.http.post<any>(url, {
      PostAlias: postAlias
    })
      .pipe(
        catchError(this.handleError<any[]>('GetRelatedBlogs', []))
      );
  }



  GetLocations() {
    return new Promise((resolve, reject) => {
      this.GetLocationsData().subscribe(data => {
        data.sort((a, b) => (a.alt_name > b.alt_name) ? 1 : -1);

        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          data[index].lat = parseFloat(element.latitude);
          data[index].lon = parseFloat(element.longitude);
        }

        this.warehouses = data.filter(x => x.alt_name != "");
        this.warehouses = this.warehouses.filter(x => x.alt_name != null);
        this.warehouses = this.warehouses.filter(x => x.alt_name != "Corporate Office");

        this.corpOffice = data.filter(x => x.alt_name == "Corporate Office");

        resolve('');
      });
    })
  }



  GetLocationsData(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetLocations/`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetLocations', []))
      );
  }

  GetEmployees(requestType: string, location: string, organizationId: number): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetEmployees/`;
    return this.http.post<any>(url, {
      RequestType: requestType,
      Location: location,
      OrganizationId: organizationId
    })
      .pipe(
        catchError(this.handleError<any[]>('GetEmployees', []))
      );
  }

  GetLatLonFromZip() {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyAtxwf8gMKfev6w1Fzcoc2aVBeNdtnSSqA&components=postal_code:` + this.zipCodeEntered;
    return this.http.get<any>(url, {

    })
      .pipe(
        catchError(this.handleError<any[]>('GetEmployees', []))
      );
  }

  GetLocationFromLatLon(lat: number, lon: number) {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=` + lat + ',' + lon + `&key=AIzaSyAtxwf8gMKfev6w1Fzcoc2aVBeNdtnSSqA&sensor=true`;
    return this.http.get<any>(url, {

    })
      .pipe(
        catchError(this.handleError<any[]>('GetEmployees', []))
      );
  }

  GetRepsFromZip() {
    const url = `${this.appAPIUrl}/Harrells/GetRepsByZip/`;
    return this.http.post<any>(url, {
      zip: this.zipCodeEntered
    })
      .pipe(
        catchError(this.handleError<any[]>('GetRepsByZip', []))
      );
  }

  GetRepsByState(states: any) {
    //test
    const url = `${this.appAPIUrl}/Harrells/GetRepsByState/`;
    return this.http.post<any>(url, {
      States: states 
    })
      .pipe(
        catchError(this.handleError<any[]>('GetRepsByState', []))
      );
  }

  GetAllReps(repIdOptional: number) {
    const url = `${this.appAPIUrl}/Harrells/GetAllReps/`;
    return this.http.post<any>(url, {
      Id: repIdOptional
    })
      .pipe(
        catchError(this.handleError<any[]>('GetAllReps', []))
      );
  }

  GetAllStates() {
    const url = `${this.appAPIUrl}/Harrells/GetAllStates/`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetAllStates', []))
      );
  }

  GetAllSegments() {
    const url = `${this.appAPIUrl}/Harrells/GetAllSegments/`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetAllSegments', []))
      );
  }

  GetDepartments() {
    const url = `${this.appAPIUrl}/Harrells/GetDepartments/`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetDepartments', []))
      );
  }

  GetParticleSizes() {
    const url = `${this.appAPIUrl}/Harrells/GetParticleSizes/`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetParticleSizes', []))
      );
  }

  GetSpreaderList(particleSizeId: number) {
    const url = `${this.appAPIUrl}/Harrells/GetSpreaderList/`;
    return this.http.post<any>(url, {
      Id: particleSizeId
    })
      .pipe(
        catchError(this.handleError<any[]>('GetSpreaderList', []))
      );
  }

  GetSpeeds() {
    const url = `${this.appAPIUrl}/Harrells/GetSpeeds/`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetSpeeds', []))
      );
  }

  //element percent, pounds, product density, spreader id, speed
  GetSpreaderCalculator(elementPercent: number, pounds: number, density: number, spreaderId: number, speed) {
    const url = `${this.appAPIUrl}/Harrells/GetSpreaderCalculator/`;
    return this.http.post<any>(url, {
      ElementPercent: elementPercent,
      Pounds: pounds,
      ProductDensity: density,
      SpreaderId: spreaderId,
      SpreaderSpeedDefined: speed
    })
      .pipe(
        catchError(this.handleError<any[]>('GetSpreaderCalculator', []))
      );
  }

  GetFoliarCalculator(foliarItemNmbr: string, jugsPerTank: number, acresPerTank: number) {
    const url = `${this.appAPIUrl}/Harrells/GetFoliarCalculator/`;
    return this.http.post<any>(url, {
      ItemNmbr: foliarItemNmbr,
      JugsTank: jugsPerTank,
      AcresTank: acresPerTank
    })
      .pipe(
        catchError(this.handleError<any[]>('GetFoliarCalculator', []))
      );
  }

  GetFoliarItems() {
    const url = `${this.appAPIUrl}/Harrells/GetFoliarItems/`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetFoliarItems', []))
      );
  }

  GetRepInfoForUser() {
    const url = `${this.appAPIUrl}/Harrells/GetRepInfoForUser/`;
    return this.http.post<any>(url, {
      Email: JSON.parse(sessionStorage.getItem('loggedInMyHarrellsUser')).Email
    })
      .pipe(
        catchError(this.handleError<any[]>('GetRepInfoForUser', []))
      );
  }


  GetThirdPartyJobPostings() {
    const url = `https://theapplicantmanager.com/jobfeeds/h5.js`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetThirdPartyJobPostings', []))
      );
  }

  GetBillandHoldDetail(): Observable<any> {
    const url = `${this.appAPIUrl}/Harrells/GetBillandHoldDetail/?OnlineID=${this.bhGUID}`;

    return this.http.get<any>(url)
      .pipe(
        catchError(this.handleError<any[]>('getTrailerLog', []))
      );
  }

  SubmitBillAndHold(ipAddress: string, title: string, bhId: string, signature: string, printedName: string, dateSigned: Date): Observable<any> {
    const url = `${this.appAPIUrl}/Harrells/SubmitBillandHold/`;

    return this.http.post<any>(url, {
      Title: title,
      OnLineID: this.bhGUID, //this is the guid
      Signature: signature,
      PrintName: printedName,
      IPAddress: ipAddress,
      AgreementDate: dateSigned

    })
      .pipe(
        catchError(this.handleError<any[]>('SubmitBillAndHold', []))
      );
  }

  GetSiteSearch(searchType: string, searchTerm: string, loggedInUserEmail: string, isAdmin): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetSiteSearch/`;
    return this.http.post<any>(url, {
      SearchResultType: searchType,
      SearchTerm: searchTerm,
      LoggedInUserName: loggedInUserEmail,
      IsAdmin: isAdmin
    })
      .pipe(
        catchError(this.handleError<any[]>('GetSiteSearch', []))
      );
  }

  GetClientIP() {
    const url = `https://api.ipify.org?format=json`;
    return this.http.get<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetClientIP', []))
      );
  }

  checkIfImageExists(url, callback) {
    const img = new Image();
    img.src = url;

    if (img.complete) {
      callback(true);
    } else {
      img.onload = () => {
        callback(true);
      };

      img.onerror = () => {
        callback(false);
      };
    }
  }

  CalculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in kilometers

    return distance;
  }

  deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }


  HtmlStringToPlainText(htmlString: string): string { //converts html string to plain text
    // var temp = document.createElement("div");
    // temp.innerHTML = htmlString;
    // return temp.textContent || temp.innerText || "";
    if (htmlString == null)
      htmlString = '';

    return htmlString.replace(/<(?:.|\n)*?>/gm, ' ');

  }


  getDocument(docType: string, id2: string, id3?: string): Observable<any> {
    const url = `${this.harfilesAPIUrl}/docs/getDocument`;

    return this.http.post<any>(url, { DocType: docType, Id2: id2, Id3: id3 })
      .pipe(
        catchError(this.handleError<any[]>('getDocument', []))
      );
  }

  DisplaySDSPDF(itemNmbr: string) {
    this.getDocument('sds', itemNmbr)
      .subscribe(response => {

        if (response.length == 0 || response[0].FileExists == false) {
          if (itemNmbr == '' || itemNmbr == null){
            this.product.WebName = ' -- Item not selected --'
          }
          this.displaySDSNotice = true
        } else if (response && response.length > 0 && response[0]) {
          window.open(response[0].DocName, "_blank");
        }
      });
  }


  DisplayLabelPDF(itemNmbr: string) {
    this.getDocument('label', itemNmbr)
      .subscribe(response => {

        if (response.length == 0 || response[0].FileExists == false) {
          if (itemNmbr == '' || itemNmbr == null){
            this.product.WebName = ' -- Item not selected --'
          }
          this.displayLabelNotice = true
        }
        else {
          window.open(response[0].DocName, "_blank");
        }
      })
  }

  mustBeDigitAllowPeriods(event) {
    var key = (event.which) ? event.which : event.keyCode;

    if (key < 48 || key > 57) {
      if (key == 46) {
        //period - do nothng
      }
      else {
        event.preventDefault();
      }
    }
  }

  mustBeDigitNoPeriods(event) {
    var key = (event.which) ? event.which : event.keyCode;

    if (key < 48 || key > 57) {
      event.preventDefault();
    }
  }

  onlyOnePeriod(event) {
    //only one period allowed, if user types 2 the first one is removed
    event.target.value = event.target.value.replace(/\.(?=.*\.)/g, '');
    return;
  }

  ShowSpinnerModal() {
    document.getElementById("spinnerModal").style.display = "block";
    document.getElementById("spinnerModal").focus();
  }


  HideSpinnerModal() {
    document.getElementById("spinnerModal").style.display = "none";
  }

  // SetActiveLink(linkToSet: string) {
  //   sessionStorage.setItem('activeLink',linkToSet);
  //   //this.activeLink = linkToSet;
  // }
  




  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // // TODO: send the error to remote logging infrastructure
      // console.error(error); // log to console instead

      // // TODO: better job of transforming error for user consumption
      // console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
